<template>
  <div class="food-search-results-dialog">
    <mu-content-block class="blueHeader">
      <mu-flexbox>
        <mu-flexbox-item>
          {{title}}
        </mu-flexbox-item>
        <mu-flexbox-item align="right">
          <md-icon
            slot="default"
            style="cursor:pointer"
            @click.native="closeDialog('addFoodDialog')"
            v-text="'close'"
          >
          </md-icon>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>
    <mu-paper style="position: relative; z-index: 99">
      <mu-list>
        <mu-list-item disableRipple>
          <div slot="title">
            <span v-text="searchTerm"></span>
          </div>
          <div slot="after" v-if="!isLoading">
            <span v-text="results.length"></span> of <span v-text="options.total_results +  ' ' + $t('message.labelFoods')"></span>
          </div>
          <mu-icon @click.native="$emit('goBack', 'a')" slot="left" value="chevron_left"></mu-icon>
        </mu-list-item>
      </mu-list>
    </mu-paper>
    <div class="scrollable-area" id="resultScroller">
      <mu-flexbox v-if="isLoading" align="center" justify="center" style="height: 100%">
        <mu-flexbox-item align="center">
          <mu-circular-progress :size="24"></mu-circular-progress>
          <br/>
          <span v-text="$t('message.loadingText')"></span>
        </mu-flexbox-item>
      </mu-flexbox>
      <mu-list v-if="!isLoading && results.length === 0" class="oddEven">
        <mu-list-item
          :title="$t('message.labelFoodSearchResultsEmpty')"
        >
          <mu-icon slot="left" value="warning"/>
        </mu-list-item>
      </mu-list>
      <mu-list v-if="!isLoading && results.length >= 1" class="oddEven">
        <mu-list-item
          v-for="result, index in results"
          :key="'result-' + index"

          disableRipple
          @click.native="selectFood(result)"
        >
          <div slot="title" v-text="result.food_name" v-once></div>
          <div slot="describe">

            <div v-text="result.food_description"></div>
            <div class="brandName" v-if="result.brand_name" v-text="result.brand_name"></div>
          </div>
          <div slot="after" v-once></div>
          <mu-icon slot="right" value="add_circle" v-once/>
        </mu-list-item>

        <div
          v-if="!isAppending && options.total_results > results.length"
          id="infinite-scroll-detector"
        ></div>
      </mu-list>
      <div align="center" v-if="isAppending" style="padding: 24px;">
        <mu-circular-progress
          :size="24"
        ></mu-circular-progress>
      </div>

    </div>
  </div>
</template>
<script>

  import FoodApi from '../../../api/Food';
  import {Observable} from 'rxjs';

  let optionsDefault = {
    page_number: 0,
    max_results: 10,
    total_results: 0
  };

  export default {
    name: 'fd-search-results-dialog',
    props: {
      title: {
        type: String,
        default: ""
      },
      searchTerm: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        isAppending: false,
        isLoading: true,
        options: optionsDefault,
        results: []
      }
    },
    watch: {
      'searchTerm': function () {
        let self = this;
        self.getData();
      }
    },
    mounted() {
      let self = this;
      if (self.searchTerm !== "") {
        self.getData();
      }

      self.initScrollFix();
      $(window).resize(function () {
        self.initScrollFix();
      });

      let element = document.getElementById('resultScroller');
      element.addEventListener('scroll', self.handleScroll);
    },
    methods: {
      selectFood(food) {
        let self = this;
        self.$emit('foodSelected', food);
      },
      initScrollFix() {
        let $panelheight = $('.food-dialog-container').find('#md-dialog'),
          $scrollHeight = $($panelheight.prevObject[0].children[0]).outerHeight() - (54 + 48 );
        $('.food-search-results-dialog .scrollable-area').attr('style', "height:" + $scrollHeight + 'px;overflow:auto');
      },
      isElementInViewport: function (el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
          el = el[0];
        }
        if (!el) {
          return;
        }
        var rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
      },
      onVisibilityChange: function (el, callback) {
        var old_visible;
        return function () {
          var visible = this.isElementInViewport(el);
          if (visible != old_visible) {
            old_visible = visible;
            if (typeof callback == 'function') {
              callback();
            }
          }
        }
      },
      handleScroll: function () {
        let self = this;
        if (!self.isAppending) {
          if (self.isElementInViewport(document.getElementById('infinite-scroll-detector'))) {
            self.loadMoreData();
          }
        }
      },
      closeDialog() {
        let self = this;
        self.$emit('closeDialog')
      },
      loadMoreData() {
        let self = this, page = self.options.page_number + 1;
        self.isAppending = true;
        FoodApi.searchFoods(self.searchTerm, page, self.options.max_results)
          .then(function (response) {
            self.options = response.data.options;
            self.results.push.apply(self.results, response.data.foods)
            self.isAppending = false;
          })
          .catch(function (error) {
            self.isAppending = false;
          });
      },
      getData() {
        let self = this;
        //self.isLoading = true;
        self.results = [];

        FoodApi.searchFoods(self.searchTerm, self.options.page_number, self.options.max_results)
          .then(function (response) {
            self.results = response.data.foods;
            self.options = response.data.options;
            self.isLoading = false;

          })
          .catch(function (error) {
            //self.isLoading = false;
            self.isLoading = false;
            self.results = [];
            self.options = optionsDefault
          })
      }
    }
  }
</script>
<style>
  .oddEven > div:nth-child(even) {
    background: #f9f9f9;;
  }

  .oddEven > div:nth-child(odd) {
    background: #ffffff;
  }

  .mu-card.add-food-dialog .food-search-dialog .show-left {
    padding-left: 72px;
  }

  .mu-card.add-food-dialog .food-search-dialog .mu-item-left {
    left: 24px;
  }

  .brandName {
    margin-top: 4px;
    color: rgba(32, 32, 32, 0.64);
  }

  .food-search-results-dialog .mu-item.show-left {
    padding-left: 58px;
  }

  .food-search-results-dialog .mu-item-text {
    max-height: initial !important;
    min-height: initial !important;
  }

</style>



// WEBPACK FOOTER //
// SearchResultsDialog.vue?445b9653